import React from "react";

import Select from "react-select"
import { GlobalContext } from "../../../../utils/globalprovider.js";
import "./combos.css"

class ComboTypeConf extends React.Component
{
    static contextType = GlobalContext;
    constructor(props)
    {
        super (props);

        this.state = {
            listetype: [],
            selectedType: null, 
        }

    }

    customStyles = {
        container: (base) => ({
        ...base,
        width: "96.2%",
        marginLeft: "1%"
        }),

        control: (base) => ({
        ...base,
        border:  "none",
        boxShadow: "none",
        backgroundColor: "#000",
        color: "#fff",
        minHeight: "30px"
        }),

        singleValue: (base) => ({
        ...base,
        color: "#fff",
        fontSize: "13px"
        }),

        menu: (base) => ({
        ...base,
        backgroundColor: "#000"
        }),

        option: (base, state) => ({
        ...base,
        backgroundColor: state.isFocused ? "#333" : "#000",
        color: "#fff",
        fontSize: "13px",
        cursor: "pointer"
        }),

        input: (base) => ({
        ...base,
        color: "#fff",
        fontSize: "13px"
        })
    };


    formatOptionLabel = ({ value,label, image }) => {

    const emptyImage =     "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=";

    return (
                <div style={{ display: "flex", alignItems: "center" }}>
                <img
                    src={image ? image : emptyImage}
                    alt=""
                    style={{
                    width: 20,
                    height: 20,
                    marginRight: 8,
                    objectFit: "cover"
                    }}
                />
                <span>{value===0?"":String(value).padStart(4, " ")} &nbsp; {label}</span>
                </div>
            ) ;
    }
    
    
    handleChange = (selectedOption) => 
        {
    this.setState({ selectedType: selectedOption });

    if (this.props.onChange)
        this.props.onChange (selectedOption.value);
    };

    componentDidMount()
    {

      const options = [
        {value:0, label:this.context.language=="fr"?"Non spécifié":"Unspecified"},
        {value:1, label:this.context.language=="fr"?"Sous-titrage classique":"Classic subtitling"},
        {value:2, label:this.context.language=="fr"?"Sous-titrage télétexte":"Teletext subtitling"},
      ]
        var selected = options.find(o => o.value === this.props.typeconf);
        if (!selected) 
            selected = options.find(o => o.value === 0);

        this.setState( {
        options: options,
        selectedType: selected,
        });        
    }

    render()
    {

    return (
                    <Select
                    options={this.state.options}
                    value={this.state.selectedType}
                    onChange={this.handleChange}
                    formatOptionLabel={this.formatOptionLabel}
                    styles={ this.customStyles}
                    />
    );    
    }
}


ComboTypeConf.defaultProps = 
{ 
    typeconf : 0,
}

export default ComboTypeConf;
